export default "__VITE_ASSET__xQEEMRWI__"